export default "__VITE_ASSET__8ftvE5Y9s6eu6XTIqdB91w__"